import { render, staticRenderFns } from "./addCourseDialog.vue?vue&type=template&id=c8967a00&scoped=true&"
import script from "./addCourseDialog.vue?vue&type=script&lang=js&"
export * from "./addCourseDialog.vue?vue&type=script&lang=js&"
import style0 from "./addCourseDialog.vue?vue&type=style&index=0&id=c8967a00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8967a00",
  null
  
)

export default component.exports